import chat from './chat';
import whatsapp from './whatsapp';
import voice from './voice';
import inbox from './inbox';

export default {
  chat,
  whatsapp,
  voice,
  inbox,
};
